import React from "react";
import classNames from "classnames";
import './Minimodel.css'

function MiniModel (props) {
	const [hidden, setHidden] = React.useState(false)
	const five = props.five
	const miniModeRef = React.useRef(null)
	
	const BoxStyle = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: "absolute",
		top: '40px',
		right: '20px',
		padding: '10px',
		width: '75px',
		height: '100px',
		background: 'linear-gradient(transparent, rgba(0, 0, 0, .2))',
	}
	
	React.useEffect(() => {
		if (!miniModeRef.current) return
		const minimodel = five.plugins.minimodel
		const height = miniModeRef.current.clientHeight
		const width = miniModeRef.current.clientWidth
		minimodel.appendTo(miniModeRef.current, { height, width })
	}, [five.plugins.minimodel])
	
	five.on('modeChange', (mode, prevMode) => {
		if (mode === 'Floorplan') {
			return setHidden(true)
		}
		setHidden(false)
	})
	
	
	return (
		<div className={classNames("minimodel-wrap", {'minimodel-wrap__hidden': hidden})}>
			<div
				onClick={() => five.setState({ mode: "Floorplan" })}
				style={{...BoxStyle}}
				ref={miniModeRef}
			/>
		</div>
	)
}

export default MiniModel
